export const QUESTIONNAIRE_ENTRY = 'entry';
export const QUESTIONNAIRE_QUESTION = 'question';
export const QUESTIONNAIRE_EXIT = 'exit';
export const QUESTIONNAIRE_FAILED_QUESTIONS = 'failed-questions';
